module.exports = __webpack_public_path__ + "static/img/截屏2024-08-02 16.38.17.f48ac273.png";